import { type FC } from 'react';

import { Timer } from '@/components/common/Timer/Timer';

interface UpdateContractTimerUiProps {
  seconds: number;
}

const UpdateContractTimerUi: FC<UpdateContractTimerUiProps> = ({ seconds }) => {
  return (
    <div className="bg-[#FFFFFF0D] py-[2px] px-[8px] rounded-full">
      <Timer seconds={seconds} className="!text-[14px]" />
    </div>
  );
};

export { UpdateContractTimerUi };
